import { StyledCard } from '@/app/features/common/DetailStyles';
import { FlexItemCenterDiv } from '@/app/shared/common.StyledComponents';
import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const InvoicesSummaryDetailCard = styled(StyledCard)`
  padding: ${rem(12)};
  border: ${rem(1)} solid ${({ theme }: any) => theme.colors.greyscale.gray15};
  border-radius: ${rem(4)};
  box-shadow: none;
  position: relative;
  flex: 1;
  min-height: 0;
  height: auto;
  font-family: ${({ theme }) => theme.typography.fontFamilies.primary};
  line-height: ${({ theme }) => theme.typography.lineHeights.body.medium};
  color: black;
`;

export const CardHeader = styled.div`
  display: flex;
  white-space: nowrap;
`;

export const FilterLink = styled.div`
  margin-left: auto;
  padding-left: ${rem(42)};
`;

export const InvoicesAmount = styled(FlexItemCenterDiv)`
  text-align: center;
  padding: ${rem(12)} 0 ${rem(24)};
`;
